"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
var _fastLink = _interopRequireDefault(require("./fast-link"));
require("./left-menu.css");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var _wr = function _wr(type) {
  var orig = window.history[type];
  return function () {
    var rv = orig.apply(this, arguments);
    var e = new Event(type);
    e.arguments = arguments;
    window.dispatchEvent(e);
    return rv;
  };
};
window.history.pushState = _wr("pushState");
window.history.popstate = _wr("popstate");
window.history.replaceState = _wr("replaceState");
function findPath(subItems) {
  return subItems.path === window.location.pathname;
}
function findPathRegexp(subItems) {
  if (!subItems.pathRegexp) return false;
  var isValid = true;
  try {
    new RegExp(subItems.pathRegexp);
  } catch (e) {
    isValid = false;
  }
  if (!isValid) return false;
  return window.location.pathname.match(subItems.pathRegexp);
}
function findPathParams(subItems) {
  if (!subItems.path) return false;
  var pathParams = "^" + subItems.path.replace(/\//gi, "\\/").replace(/:[0-9a-z_.%@-]+/gi, '[0-9a-z_.%-]+') + "$";
  // console.log("LEFT MENU findPathParams pathParams: ", pathParams)
  var isValid = true;
  try {
    pathParams = new RegExp(pathParams, 'gi');
  } catch (e) {
    isValid = false;
  }
  if (!isValid) return false;
  return window.location.pathname.match(pathParams);
}
var LeftMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(LeftMenu, _React$Component);
  var _super = _createSuper(LeftMenu);
  function LeftMenu(props) {
    var _this;
    _classCallCheck(this, LeftMenu);
    _this = _super.call(this, props);
    _this.state = {};
    _this.menu = [];
    _this.openKeys = _this.defaultOpenKeys();
    _this.timeout1 = false;
    _this.timeout2 = false;
    _this.createMenu();
    window.addEventListener("replaceState", function (e) {
      return _this.rerender(e);
    });
    window.addEventListener("popstate", function (e) {
      return _this.rerender(e);
    });
    window.addEventListener("pushState", function (e) {
      return _this.rerender(e);
    });
    return _this;
  }
  _createClass(LeftMenu, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props !== prevProps) {
        this.menu = [];
        this.createMenu();
        this.setState({});
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.modal = document.getElementById('modals');
      this.modal.addEventListener("mouseover", function () {
        return _this2.modalShow();
      });
      this.modal.addEventListener("mouseout", function () {
        return _this2.modalHide();
      });
    }
  }, {
    key: "checkSubItems",
    value: function checkSubItems(array, parent) {
      var _this3 = this;
      var subMenus = array.filter(function (e) {
        return e.subMenu;
      });
      var parentOpened = false;
      var i = 0;
      subMenus.forEach(function (subMenu) {
        if (subMenu.subMenu.filter(findPath)[0]) {
          _this3.selected = subMenus[i].path;
          parentOpened = true;
        }
        i++;
      });
      var featuredFunctions = array.filter(function (e) {
        return e.featured;
      });
      i = 0;
      featuredFunctions.forEach(function (featuredFunction) {
        if (featuredFunction.featured.filter(findPath)[0]) {
          _this3.selected = featuredFunctions[i].path;
          parentOpened = true;
        }
        i++;
      });
      var relatedItems = array.filter(function (e) {
        return e.related;
      });
      i = 0;
      relatedItems.forEach(function (relatedItem) {
        if (relatedItem.related.filter(findPathRegexp)[0]) {
          _this3.selected = relatedItems[i].path;
          parentOpened = true;
        }
        if (relatedItem.related.filter(findPathParams)[0]) {
          _this3.selected = relatedItems[i].path;
          parentOpened = true;
        }
        i++;
      });
      if (!parentOpened) {
        return false;
      } else {
        return parent;
      }
    }
  }, {
    key: "defaultOpenKeys",
    value: function defaultOpenKeys() {
      var _this4 = this;
      var openKeys = [];
      this.checkSubItems(this.props.menuItems, false);
      var menuGroups = this.props.menuItems.filter(function (e) {
        return e.group;
      });
      var i = 0;
      menuGroups.forEach(function (menuGroup) {
        var key = "group_" + menuGroup.path + menuGroup.key;
        if (menuGroup.group.filter(findPath)[0]) openKeys.push(key);
        if (_this4.checkSubItems(menuGroup.group, menuGroups[i].path)) openKeys.push(key);
        i++;
      });
      return openKeys;
    }
  }, {
    key: "groupHandler",
    value: function groupHandler(e, key, popup, subMenu) {
      e.preventDefault();
      e.stopPropagation();
      if (this.props.collapsed) return;
      if (this.modal.style.display === 'block') {
        this.HandleGroupTitleOnMouseOut(e);
      } else {
        this.HandleGroupTitleOnMouseOver(e, true, subMenu);
      }
      if (this.openKeys.includes(key)) {
        this.openKeys = this.openKeys.filter(function (e) {
          return e !== key;
        });
      } else {
        this.openKeys.push(key);
      }
      this.menu = [];
      var selected = this.createMenu();
      this.setState({});
    }
  }, {
    key: "rerender",
    value: function rerender(e) {
      this.menu = [];
      this.selected = [];
      this.openKeys = this.defaultOpenKeys();
      this.createMenu();
      this.setState({});
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this5 = this;
      window.removeEventListener("replaceState", function (e) {
        return _this5.rerender(e);
      });
      window.removeEventListener("popstate", function (e) {
        return _this5.rerender(e);
      });
      window.removeEventListener("pushState", function (e) {
        return _this5.rerender(e);
      });
    }

    /* Generating of menu */
  }, {
    key: "createMenu",
    value: function createMenu() {
      var _this6 = this;
      this.menu = [];
      var selected = [],
        defaultOpenKeys = [];
      this.props.menuItems.forEach(function (item) {
        _this6.createItem(item, "menuItemNew", _this6.menu);
      });
      this.menu = /*#__PURE__*/_react["default"].createElement("div", {
        className: "mainMenu",
        key: "mainMenu"
      }, this.menu);
      //  return selected;
    }
  }, {
    key: "modalShow",
    value: function modalShow() {
      this.clearTimeouts();
      this.modal.style.display = 'block';
    }
  }, {
    key: "modalHide",
    value: function modalHide() {
      var _this7 = this;
      if (this.timeout2) return;
      this.timeout2 = setTimeout(function () {
        _this7.modal.style.display = 'none';
      }, 500);
    }
  }, {
    key: "HandleGroupTitleOnMouseOver",
    value: function HandleGroupTitleOnMouseOver(e, popup, submenu, path) {
      if (!popup && !this.props.collapsed) return;
      this.clearTimeouts();
      this.modal.style.display = 'block';
      this.modal.className = '';
      this.props.modal(submenu);
      var item = e.target;
      while (item.className !== 'groupTitleNew') {
        item = item.parentNode;
      }
      var rect = item.getBoundingClientRect();
      //    console.log('HandleGroupTitleOnMouseOver',this.openKeys.includes(path) , popup, this.props.collapsed, rect.top, rect.right, rect.bottom, rect.left, item, submenu);
      if (window.innerHeight / 2 > rect.top) {
        this.modal.style.top = rect.top + 'px';
        this.modal.style.maxHeight = window.innerHeight - rect.top - 12 + 'px';
        this.modal.style.bottom = 'auto';
      } else {
        this.modal.style.top = 'auto';
        this.modal.style.bottom = window.innerHeight - rect.bottom + 'px';
        this.modal.style.maxHeight = rect.bottom - 12 + 'px';
      }
      this.modal.style.left = rect.right + 12 + 'px';
    }
  }, {
    key: "HandleGroupTitleOnMouseOut",
    value: function HandleGroupTitleOnMouseOut(e) {
      var _this8 = this;
      if (this.timeout1 || this.modal.style.display === 'none') return;
      this.timeout1 = setTimeout(function () {
        _this8.modal.style.display = 'none';
      }, 500);
    }
  }, {
    key: "clearTimeouts",
    value: function clearTimeouts() {
      clearTimeout(this.timeout1);
      clearTimeout(this.timeout2);
      this.timeout1 = false;
      this.timeout2 = false;
    }
  }, {
    key: "createItem",
    value: function createItem(item, currentClass, array, popup) {
      var _this9 = this;
      var linkClass = currentClass + "link",
        divClass = currentClass,
        content = [],
        title = [/*#__PURE__*/_react["default"].createElement("div", {
          className: "label",
          key: item.path + item.title + item.key
        }, item.title)];
      if (item.path === this.selected) {
        linkClass = linkClass + " Selected";
        divClass = divClass + " Selected";
      }
      if (item.badge) title.push( /*#__PURE__*/_react["default"].createElement("div", {
        className: "badgeContainer",
        key: "badgeContainer"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "badge"
      }, item.badge)));
      if (item.icon) content.push( /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: "material-icons-round",
        key: "icon"
      }, item.icon));
      content.push( /*#__PURE__*/_react["default"].createElement("div", {
        className: "title",
        key: "title"
      }, title));
      if (item.group) {
        var key = "group_" + item.path + item.key;
        var arrow,
          subMenuClassName,
          _popup,
          subMenu = [];
        if (this.openKeys.includes(key)) {
          arrow = "keyboard_arrow_down";
          subMenuClassName = 'subMenu';
          _popup = false;
        } else {
          arrow = "keyboard_arrow_right";
          subMenuClassName = 'hiddenSubMenu';
          _popup = true;
        }
        var g = 0;
        item.group.forEach(function (groupedItem) {
          _this9.createItem(groupedItem, "groupedMenuItemNew", subMenu, _popup);
        });
        array.push( /*#__PURE__*/_react["default"].createElement("div", {
          className: "groupTitleNew",
          key: key,
          onClick: function onClick(e) {
            return _this9.groupHandler(e, key, _popup, subMenu);
          },
          onMouseOver: function onMouseOver(e) {
            return _this9.HandleGroupTitleOnMouseOver(e, _popup, subMenu, item.path);
          },
          onMouseOut: function onMouseOut(e) {
            return _this9.HandleGroupTitleOnMouseOut(e);
          }
        }, content, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          className: "material-icons-round arrow",
          key: "arrow"
        }, arrow)));
        this.menu.push( /*#__PURE__*/_react["default"].createElement("div", {
          className: subMenuClassName,
          key: "subMenu" + item.path
        }, subMenu));
      } else {
        array.push( /*#__PURE__*/_react["default"].createElement(_fastLink["default"], {
          "class": linkClass,
          url: item.path.replace(/([%])/gi, encodeURIComponent("$1")),
          key: item.path + item.key
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: divClass,
          onMouseOver: function onMouseOver(e) {
            if (currentClass === 'menuItemNew') {
              _this9.showTitlePopup(e, item.title);
            }
          },
          onMouseOut: function onMouseOut(e) {
            return _this9.HandleGroupTitleOnMouseOut(e);
          },
          onClick: function onClick() {
            _this9.modal.style.display = 'none';
            if (window.innerWidth <= 800) {
              var elem1 = document.getElementById("navigationDrawer");
              var elem2 = document.getElementById("mobileMask");
              elem1.classList.remove("visible");
              elem2.className = "";
            }
          }
        }, content)));
      }
    }
  }, {
    key: "showTitlePopup",
    value: function showTitlePopup(e, title) {
      if (!this.props.collapsed) return;
      this.clearTimeouts();
      this.modal.style.display = 'block';
      this.modal.className = 'title';
      this.props.modal(title);
      var item = e.target;
      while (item.className !== 'menuItemNew') {
        item = item.parentNode;
      }
      var rect = item.getBoundingClientRect();
      this.modal.style.top = rect.top + 12 + 'px';
      this.modal.style.left = rect.right + 12 + 'px';
    }
  }, {
    key: "render",
    value: function render() {
      return this.menu;
    }
  }]);
  return LeftMenu;
}(_react["default"].Component);
var MenuItem = function MenuItem(props) {
  return;
};
var _default = exports["default"] = LeftMenu;